import { render, staticRenderFns } from "./invest_qrcode.vue?vue&type=template&id=ecca287a&scoped=true&"
import script from "./invest_qrcode.vue?vue&type=script&lang=js&"
export * from "./invest_qrcode.vue?vue&type=script&lang=js&"
import style0 from "./invest_qrcode.vue?vue&type=style&index=0&id=ecca287a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecca287a",
  null
  
)

export default component.exports